(() => {
  'use strict';
  if (window.__gnwStudioV7) return;
  window.__gnwStudioV7 = true;
  // Native header structure is retained. Collapse before a long menu can wrap.
  let fitFrame;
  const fitCenteredHeader = () => {
    cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(() => {
      const header = document.getElementById('SiteHeader');
      if (!header || !header.querySelector('.header-layout--center')) return;
      header.removeAttribute('data-gnw-v7-compact');
      if (innerWidth < 990) return;
      const container = header.querySelector('.gnwv7-header-navigation');
      const list = container && container.querySelector('.site-navigation');
      if (list && container.clientWidth && list.scrollWidth > container.clientWidth + 2) header.setAttribute('data-gnw-v7-compact', 'true');
    });
  };
  addEventListener('resize', fitCenteredHeader, {passive:true});
  document.addEventListener('shopify:section:load', fitCenteredHeader);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCenteredHeader);
  // The guide is informational only: never create cart properties or touch an app.
  let returnFocus;
  const initDialog = () => {
    const dialog = document.getElementById('GnwGuideDialogV7');
    if (!dialog || dialog.dataset.gnwReady) return;
    dialog.dataset.gnwReady = 'true';
    dialog.querySelector('[data-gnw-guide-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-gnw-guide-zoom]').addEventListener('click', event => {
      const zoomed = dialog.classList.toggle('is-zoomed');
      event.currentTarget.setAttribute('aria-pressed', String(zoomed));
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('gnwv7-guide-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
      returnFocus = null;
    });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest && event.target.closest('a[data-gnw-guide]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const dialog = document.getElementById('GnwGuideDialogV7');
    if (!dialog || typeof dialog.showModal !== 'function') return; // Original link remains a no-JS fallback.
    initDialog();
    event.preventDefault();
    returnFocus = trigger;
    const image = dialog.querySelector('[data-gnw-guide-image]');
    dialog.querySelector('#GnwGuideTitleV7').textContent = trigger.dataset.guideTitle;
    image.alt = trigger.dataset.guideAlt || trigger.dataset.guideTitle;
    image.width = Number(trigger.dataset.guideWidth) || 1200;
    image.height = Number(trigger.dataset.guideHeight) || 1200;
    image.src = trigger.href; // Original sheet is loaded only after the user asks for it.
    dialog.querySelector('[data-gnw-guide-original]').href = trigger.href;
    dialog.classList.remove('is-zoomed');
    dialog.querySelector('[data-gnw-guide-zoom]').setAttribute('aria-pressed','false');
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('gnwv7-guide-open');
    dialog.querySelector('.gnwv7-guide-dialog__body').scrollTo(0,0);
  });
  const start = () => {fitCenteredHeader();initDialog();};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
